import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { SERVER_BASE_URL } from "./Config";

interface PharmacyLoginProps {
  onLogin: (token: string, mustChangePassword: boolean, permissionLevel: string) => void;
}

const PharmacyLogin: React.FC<PharmacyLoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${SERVER_BASE_URL}/auth/pharmacist`, { email, password });
      const { access_token, must_change_password, permission_level } = response.data;
      onLogin(access_token, must_change_password || false, permission_level || 'full_access');
      if (must_change_password) {
        navigate('/pharmacy-change-password');
      } else {
        navigate('/pharmacy');
      }
    } catch (err) {
      setError('Invalid pharmacist credentials');
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '300px', margin: 'auto', marginTop: '100px' }}>
      <h2>Pharmacist Login</h2>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ marginBottom: '10px', padding: '8px' }}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ marginBottom: '10px', padding: '8px' }}
      />
      <button onClick={handleLogin} style={{ padding: '8px' }}>Login</button>
      {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
    </div>
  );
};

export default PharmacyLogin;
